export default __webpack_public_path__ + "static/media/SZ05.edaec678.mp3";